import { render, staticRenderFns } from "./christmas-gifts.vue?vue&type=template&id=5e0119cc&scoped=true"
import script from "./christmas-gifts.vue?vue&type=script&lang=js"
export * from "./christmas-gifts.vue?vue&type=script&lang=js"
import style0 from "./christmas-gifts.vue?vue&type=style&index=0&id=5e0119cc&prod&scoped=true&lang=css"
import style1 from "./christmas-gifts.vue?vue&type=style&index=1&id=5e0119cc&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0119cc",
  null
  
)

export default component.exports